import { updateClasses } from './settings/settings.middleware';

const STORAGE_KEY = 'mya-app-settings';


/**
 * Use this function if you need to call a middleware
 * when setting the initial state.
 */
const callMiddlewares = state => {
    // Since a middlwrare is requried to modify the DOM in this case
    // for settings and themes, is necessary to call middleware
    // directly to set the initial state loaded from storage
    updateClasses(state);
}

/* Use an IIFE to export the persisted state in a variable */
export const persistedState = (() => {
    try {
        const rawState = localStorage.getItem(STORAGE_KEY);
        if (rawState === null) return undefined;
        const state = JSON.parse(rawState);

        // group/client are practice-specific display state, always re-resolved
        // from the current URL/API — never restore them from a previous
        // session's storage (that was the source of the cross-practice leak).
        // `patient` is intentionally kept: it's the patient's login/session
        // state, expected to survive a hard reload like any normal login
        // session, and AutoRequest already revalidates it against the freshly
        // loaded group on every /e/ entry and logs out on a mismatch.
        delete state.group;
        delete state.client;

        callMiddlewares(state);
        return state;
    } catch (err) {
        return undefined;
    }
})();

/* Export a method to save state on each store update */
export const saveState = (state) => {
    try {
        let settingsFilter = JSON.parse(JSON.stringify(state.settings)); // deep clone

        ['offsidebarOpen', 'asideToggled', 'horizontal'] // states which we don't want to persist.
            .forEach(item => delete settingsFilter[item])

        // group/client are practice-specific and must always be re-resolved
        // from the current URL/API rather than restored from a previous
        // session. `patient` (the login/session state) is persisted like any
        // normal login session — see the read-side comment above.
        const rawState = JSON.stringify({ settings: settingsFilter, patient: state.patient });
        localStorage.setItem(STORAGE_KEY, rawState);
    } catch (err) {
        // Ignore write errors.
    }
};